import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalCurrentUser: ExperimentalQueries['experimentalCurrentUser'] = (
	_,
	__,
	{ network },
) =>
	fetchJSON(network, `/wiki/rest/api/user/current`, {
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(
		(data) => ({
			timeZone: data?.timeZone,
		}),
		() => ({
			timeZone: undefined,
		}),
	);
